var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayeeRelation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M1.29803 1H2.1016C2.16053 1 2.20874 1.04821 2.20874 1.10714V5.37798H8.71767V4.06697C8.71767 3.97723 8.82213 3.92634 8.89178 3.98259L11.4589 5.81592C11.4717 5.82595 11.4821 5.83875 11.4892 5.85337C11.4963 5.86799 11.5 5.88404 11.5 5.9003C11.5 5.91656 11.4963 5.93261 11.4892 5.94723C11.4821 5.96184 11.4717 5.97465 11.4589 5.98467L8.89178 7.81801C8.8208 7.87426 8.71767 7.82336 8.71767 7.73363V6.39583H2.04803C1.57526 6.39583 1.19088 6.01146 1.19088 5.53869V1.10714C1.19088 1.04821 1.2391 1 1.29803 1Z",
    fill: "black",
    fillOpacity: 0.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayeeRelation);
export default __webpack_public_path__ + "static/media/PayeeRelation.b796d7931f46824c472880dae125a8e7.svg";
export { ForwardRef as ReactComponent };